import React from 'react'
import { object, func } from 'prop-types'
// import { validatePostalCode } from '../../../actions/validations'
import CountrySelectInput from '../../components/CountrySelectInput/CountrySelectInput'
import { withContext } from '../../../utils/withContext'
import FaClose from 'react-icons/lib/fa/close'

import styles from './UserBillingPage.styl'

class UserBillingPage extends React.Component {

	static propTypes = {
		athlete: object,
		handleSubmit: func,
		context: object
	}

	constructor(props) {
		super(props)
		const message = this.missingInfo(props.athlete)
		this.state = { athlete: props.athlete, message }
		this.validate = this.validate.bind(this)
	}
	componentWillReceiveProps(nextProps) {
		const message = this.missingInfo(nextProps.athlete)
		this.setState({ message })
	}
	missingInfo(athlete) {
		const { taxpayerNumber } = athlete
		const { street, postalCode, city, country } = (athlete.bilingAddress || {})
		if (!taxpayerNumber) {
			return 'Número de contribuinte em falta.'
		} else if (!street || !city || !postalCode || !country) {
			return 'Informação da morada de faturação em falta.'
		} else {
			return false
		}
	}
	validate(e, athlete) {
		const { handleSubmit } = this.props
		e.preventDefault()
		if (athlete.taxpayerNumber.length !== 9) {
			// window.alert('Por favor introduz um número de contribuinte válido')
			return
		}
		handleSubmit(e, athlete)
	}
	render() {
		const { athlete, message } = this.state
		const { context: { i18n } } = this.props
		const { bilingAddress } = athlete
		return (
			<div className={ styles.dataBox }>
				<div className={ styles['content'] }>
					{ message ? <div className={ styles.missingInfo }>
						<div className={ styles.close } onClick={ () => this.setState({ message: false }) }><i><FaClose /></i></div>
						<h2>Por favor preenche a informação em falta!</h2>
						<p>{ this.missingInfo(this.props.athlete) }</p>
					</div> : null }
					<form onSubmit={ (e) => this.validate(e, athlete) }>
						<h2 className={ styles.title }>{ i18n`billing_data_label` }</h2>
						<label className={ styles.dadosContainer }>
							<label>{ i18n`registry_nif_label` }</label>
							<input type="text" size="9" value={ athlete.taxpayerNumber ? athlete.taxpayerNumber : '' } placeholder="NIF" onChange={ (e) => { this.setState({ athlete: { ...athlete, taxpayerNumber: e.target.value } }) } } />
						</label>
						<h2 className={ `${ styles.title } ${ styles.second }` }>{ i18n`registry_address_label` }</h2>
						<label className={ styles.dadosContainer }>
							<label>{ i18n`registry_address_label` }</label>
							<input type="text" value={ athlete.bilingAddress && athlete.bilingAddress.street ? athlete.bilingAddress.street : '' } placeholder="Morada" onChange={ (e) => { this.setState({ athlete: { ...athlete, bilingAddress: { ...bilingAddress, street: e.target.value } } }) } } />
						</label>
						<label className={ styles.dadosContainer }>
							<label>{ i18n`registry_postal_code_label` }</label>
							<input type="text" value={ athlete.bilingAddress && athlete.bilingAddress.postalCode ? athlete.bilingAddress.postalCode : '' } placeholder="Código Postal" onChange={ (e) => { this.setState({ athlete: { ...athlete, bilingAddress: { ...bilingAddress, postalCode: e.target.value } } }) } } />
						</label>
						<label className={ styles.dadosContainer }>
							<label>{ i18n`registry_city_label` }</label>
							<input type="text" value={ athlete.bilingAddress && athlete.bilingAddress.city ? athlete.bilingAddress.city : '' } placeholder="Cidade" onChange={ (e) => { this.setState({ athlete: { ...athlete, bilingAddress: { ...bilingAddress, city: e.target.value } } }) } } />
						</label>
						<div className={ styles.dadosContainer }>
							<label>{ i18n`registry_country_label` }</label>
							<CountrySelectInput
								className={ styles['country-select-input'] }
								onChange={ (e) => { this.setState({ athlete: { ...athlete, bilingAddress: { ...bilingAddress, country: e.target.value } } }) } }
								value={ athlete.bilingAddress && athlete.bilingAddress.country ? athlete.bilingAddress.country : '' }
							/>
						</div>
						<div className={ styles.submitButton }>
							<input type="submit" value={ i18n`save_label` } />
						</div>
					</form>
				</div>
			</div>
		)
	}
}

export default withContext(UserBillingPage)



// WEBPACK FOOTER //
// ./src/client/webapp/pages/UserBillingPage/UserBillingPage.js